import { Box, Button, Center, Heading, Image } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export default function AceleraMagentaCompletePage() {
  const [logged, setLogged] = useState<boolean>(true)

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      setLogged(false)
    }
  }, [])

  return (
    <Center marginTop={5}>
      <Box borderWidth="1px" p="5" borderRadius="lg" w="50%">
        <Center>
          <Image src="/img/acelera-magenta.png" alt="Acelera Magenta" w="65%" marginBottom="10" />
        </Center>
        <Heading as="h1" size="lg" marginBottom="5" textAlign="center">
          Acelera Magenta Concluído!
        </Heading>
        <Heading as="h2" size="md" marginBottom="5" textAlign="center">
          Obrigado por participar do Acelera Magenta!
        </Heading>

        <Center flexDirection="column">
          {logged && (
            <Link to="/acelera-magenta">
              <Button colorScheme="magenta">Retornar para página inicial</Button>
            </Link>
          )}
          <br />
          <Link to="/acelera-magenta/new">
            <Button colorScheme="magenta">Realizar um novo Acelera Magenta</Button>
          </Link>
        </Center>
      </Box>
    </Center>
  )
}
